import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60c73b06")

_pushScopeId("data-v-60c73b06")
const _hoisted_1 = { class: "-medium" }
const _hoisted_2 = { class: "step__number" }
const _hoisted_3 = { class: "step__desc" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps[_ctx.state.kind], (step, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: _ctx.state.step == index ? 'active step' : 'step'
      }, [
        _createVNode("span", _hoisted_2, _toDisplayString(index + 1), 1),
        _createVNode("span", _hoisted_3, _toDisplayString(step), 1)
      ], 2))
    }), 128))
  ]))
})